// extracted by mini-css-extract-plugin
export default {"fileWrapper":"FolderNavigation_fileWrapper__kSCMf","fileParent":"FolderNavigation_fileParent__QCat1"};